﻿import { createRoot } from 'react-dom';
import './style/theme.css'; // tokens do design system (fonte única) — carrega cedo
import App from './App';

const root = document.getElementById('root');
const rootElement = createRoot(root);
rootElement.render(<App />);
